<template>
  <modal name="adjustment-modal" :height="420" :clickToClose="false" @before-open="beforeOpen">
    <div class="kt-portlet">
      <div class="kt-portlet__head">
        <div class="kt-portlet__head-label">
          <h3 class="kt-portlet__head-title">Adjustment</h3>
        </div>
      </div>
      <div class="kt-portlet__body h-84 overflow-y-auto">
        <p>We optimize constast, adjust the colors and remove color cas</p>
        <textarea
          v-model="adjustmentInstruction"
          class="form-control"
          rows="8"
          placeholder="Order Instruction"
        ></textarea>
      </div>
      <div class="kt-portlet__foot">
        <div class="kt-form__actions kt-form__actions--right">
          <div class="row">
            <div class="col kt-align-right">
              <button type="button" class="btn btn-secondary" @click.prevent="close">Close</button>
              <button type="button" class="btn btn-brand ml-2" @click.prevent="save">Save</button>
            </div>
          </div>
        </div>
      </div>
    </div>
  </modal>
</template>

<script>
import { mapGetters } from 'vuex';
export default {
  data() {
    return {
      adjustmentInstruction: '',
    };
  },
  computed: {
    ...mapGetters({
      orderAddOns: 'order/addOns',
    }),
  },
  methods: {
    save() {
      this.$emit('adjustment', this.adjustmentInstruction);

      this.close();
    },
    close() {
      this.$emit('close');

      this.$modal.hide('adjustment-modal');
    },
    beforeOpen() {
      this.adjustmentInstruction =
        this.orderAddOns.adjustment || '';
    },
  },
};
</script>

<style>
.h-84 {
  height: 21rem !important;
}
.overflow-y-auto {
  overflow-y: auto;
}
textarea {
  resize: none !important;
}
</style>
